import { actionCreator } from 'utils';
import * as JobTypes from '../types/jobTypes';

const initState = {
    loading: false,
    error: false,
    listing: null,
    jobs: null,
    limit: 50,
    offset: 0,
    isSubmittingErrorReport: false,
    isReportErrorPopupVisible: false,
    sort: {
        key: 'expectedShippingDate',
        type: 'asc',
    },
    calcul: null,
    add: {
        loading: false,
        error: false,
        success: false,
        current: 0,
    },
    addError: {
        loading: false,
        error: false,
        success: false,
        current: 0,
    },
    filters: {
        barcode: '',
        formVersionId: '',
        formId: '',
        jobId: '',
        designId: '',
        orderItemId: '',
        customer: '',
        carpetQuality: '',
        size: '',
        machine_ids: undefined,
        startDate: [],
        expectedEndDate: [],
        status: undefined,
        quantity: '',
        palette: '',
        job_palette: '',
    },
    checked: {
        loading: false,
        ids: [],
    },
    selected: [],
};

export default function (state = initState, action) {
    switch (action.type) {
    case JobTypes.LOAD_JOBS:
        return Object.assign({}, state, {
            loading: true,
            error: false,
        });

    case actionCreator(JobTypes.LOAD_JOBS, 'res'):
        return Object.assign({}, state, {
            loading: false,
            listing: action.data,
        });

    case actionCreator(JobTypes.LOAD_JOBS, 'err'):
        return Object.assign({}, state, {
            loading: false,
            error: true,
        });

    case JobTypes.SET_JOB_FILTERS:
        return Object.assign({}, state, {
            loading: true,
            filters: {
                ...state.filters,
                [action.key]: action.value,
            },
        });

    case actionCreator(JobTypes.SET_JOB_FILTERS, 'res'):
        return Object.assign({}, state, {
            loading: false,
            listing: action.data,
        });

    case JobTypes.SET_JOB_PAGINATION:
        return Object.assign({}, state, {
            [action.key]: action.pagination,
        });

    case JobTypes.SET_JOB_SORT:
        return Object.assign({}, state, {
            sort: action.sort,
        });

    case JobTypes.RESET_JOB_FILTERS:
        return Object.assign({}, state, {
            filters: initState.filters,
        });

    case JobTypes.SET_CHECKED_JOB:
        return Object.assign({}, state, {
            checked: {
                ...state.checked,
                ids: action.ids,
            },
        });

    case JobTypes.TOGGLE_JOB_STEPS:
        return Object.assign({}, state, {
            checked: {
                ...state.checked,
                loading: action.id,
            },
        });

    case actionCreator(JobTypes.TOGGLE_JOB_STEPS, 'res') || actionCreator(JobTypes.TOGGLE_JOB_STEPS, 'err'):
        return Object.assign({}, state, {
            checked: {
                ...state.checked,
                loading: false,
            },
        });

    case JobTypes.BULK_CHECKED_JOB:
        return Object.assign({}, state, {
            checked: {
                ...state.checked,
                loading: true,
            },
        });

    case actionCreator(JobTypes.BULK_CHECKED_JOB, 'res'):
        return Object.assign({}, state, {
            checked: {
                ...state.checked,
                loading: false,
            },
        });

    case actionCreator(JobTypes.BULK_CHECKED_JOB, 'err'):
        return Object.assign({}, state, {
            checked: {
                ...state.checked,
                loading: false,
            },
        });

    case JobTypes.ADD_NEW_PALLETE_JOB:
        return Object.assign({}, state, {
            add: Object.assign({}, state.add, {
                loading: true,
                error: false,
            }),
        });

    case actionCreator(JobTypes.ADD_NEW_PALLETE_JOB, 'res'):
        return Object.assign({}, state, {
            add: Object.assign({}, state.add, {
                loading: action.loading,
                error: false,
            }),
        });

    case actionCreator(JobTypes.ADD_NEW_PALLETE_JOB, 'err'):
        return Object.assign({}, state, {
            add: Object.assign({}, state.add, {
                loading: false,
                error: action.error,
            }),
        });

    case JobTypes.ADD_NEW_ERROR_JOB:
        return Object.assign({}, state, {
            isSubmittingErrorReport: true,
        });

    case actionCreator(JobTypes.ADD_NEW_ERROR_JOB, 'res'):
        return Object.assign({}, state, {
            isSubmittingErrorReport: false,
            isReportErrorPopupVisible: false,
        });

    case actionCreator(JobTypes.ADD_NEW_ERROR_JOB, 'err'):
        return Object.assign({}, state, {
            isSubmittingErrorReport: false,
        });

    case JobTypes.REPORT_JOB_ERROR_POPUP:
        return Object.assign({}, state, {
            isReportErrorPopupVisible: action.data,
        });

    case JobTypes.SET_CALCUL_QUANTITY:
        return Object.assign({}, state, {
            calcul: action.number,
        });

    default:
        return state;
    }
}
